// ==========================================
// CART & CURRENCY DATA (FORWARD CONVERSION VIA PRODUCT)
// ==========================================

let activeCurrencyRate = 1; 
let localGoals = { tshirt: 100, freeShipping: 500 }; 

function getSubunitMultiplier(currency) {
    const zeroDecimal = ['JPY', 'KRW', 'BIF', 'CLP', 'DJF', 'GNF', 'ISK', 'KMF', 'PYG', 'RWF', 'UGX', 'VUV', 'VND', 'XAF', 'XOF', 'XPF'];
    const threeDecimal = ['BHD', 'IQD', 'JOD', 'KWD', 'LYD', 'OMR', 'TND'];
    if (zeroDecimal.includes(currency)) return 1;
    if (threeDecimal.includes(currency)) return 1000;
    return 100;
}

function fetchShopifyRate() {
    return $.ajax({
        url: "/products/exchange-rate-tool.js",
        type: "GET",
        dataType: "json"
    }).then(function(product) {
        const customerCurrency = (window.Shopify && Shopify.currency) ? Shopify.currency.active : "EUR";
        const multiplier = getSubunitMultiplier(customerCurrency);
        
        activeCurrencyRate = (product.price / multiplier) / 100.0;
        setLocalGoals();
        return activeCurrencyRate;
    }).catch(function(err) {
        console.warn("Currency tool not found, using base currency (1.0).");
        activeCurrencyRate = 1.0;
        setLocalGoals();
        return 1.0;
    });
}

function setLocalGoals() {
    const config = window.GIFT_CONFIG || { tshirtGoal: 100, freeShippingGoal: 500 };
    localGoals.tshirt = config.tshirtGoal * activeCurrencyRate;
    localGoals.freeShipping = config.freeShippingGoal * activeCurrencyRate;
}

function getCartData() {
    return $.ajax({
        url: "/cart.js",
        type: "GET",
        dataType: "json",
    }).then(function(cart) {
        const customerCurrency = (window.Shopify && Shopify.currency) ? Shopify.currency.active : "EUR";
        const multiplier = getSubunitMultiplier(customerCurrency);
        return { 
            cartTotal: cart.total_price / multiplier, 
            customerCurrency: customerCurrency,
            cartItems: cart.items 
        };
    });
}

function saveEURTotalToCart(totalEUR) {
    return fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            attributes: {
                eur_total: totalEUR
            }
        })
    }).then(res => res.json());
}

// ==========================================
// UI AND NAVIGATION JS 
// ==========================================

$(document).ready(function () {
    'use strict';
    
    $(window).on('load scroll', function () {
        var scrolling = $(this).scrollTop();
        if (scrolling > 100) {
            $('.navbar').addClass('nav-fixed')
        } else {
            $('.navbar').removeClass('nav-fixed')
        }
    })

    $(".ham-menu").click(function (event) {
        event.stopPropagation();
        $(".sidebar-wrapper").toggleClass("active");
        $(".ham-menu").toggleClass("active");
        $(".sidebar-wrapper-inner").toggleClass("active");
        $("body").toggleClass("active");
    });

    $(".mobile-menu-close-window-btn").click(function (event) {
        event.stopPropagation();
        $(".sidebar-wrapper").toggleClass("active");
        $(".ham-menu").toggleClass("active");
        $(".sidebar-wrapper-inner").toggleClass("active");
        $("body").toggleClass("active");
    });

    $('.sidebar-submenu-open').on('click', function () {
        $(this).parent().find(".megamenu-wrapper").addClass('active');
    });

    $('.sidebar-close-btn').on('click', function () {
        $(this).parent().parent().parent(".megamenu-wrapper").removeClass('active');
    });

    $(".search-bar-open-btn").click(function (event) {
        event.stopPropagation();
        $(".search-bar").toggleClass("active");
        $(".search-bar-window-close-btn").toggleClass("active");
        $("body").toggleClass("active");
    });

    $(".search-bar-window-close-btn").click(function (event) {
        event.stopPropagation();
        $(".search-bar").toggleClass("active");
        $(this).toggleClass("active");
        $("body").toggleClass("active");
    });

    $(".search-close-btn").click(function (event) {
        event.stopPropagation();
        $(".search-bar").toggleClass("active");
        $(".search-bar-window-close-btn").toggleClass("active");
        $("body").toggleClass("active");
    });

    $(".card-varient-tap-btn").click(function () {
        $(this).closest(".product-card").find(".product-varient").addClass("active");
    })

    $(".product-varient").click(function (e) {
        e.stopPropagation();
    })

    $('.product-accordion-toggle-btn').on('click', function () {
        $(this).next().slideToggle();
        $(this).parent().toggleClass('active');
        $(this).parent().siblings().removeClass('active').find('.product-accordion-item-content').slideUp();
    });

    $(".card_option").on("change", function () {
        let optionName = "";
        if($(this).hasClass("color_Swatch_option")){
            updateSwiperById($(this).attr("data-media-id"), $(this).closest(".product-card").find(".card-slider"));
            return;
        }

        $(this).closest('.product-options').find(".card_option:checked").each(function (e) {
            optionName += e !== 0 ? "-" : "";
            optionName += $(this).val();
        });
        let $card = $(this).closest(".product-card");
        let $select = $(this).closest('.product-varient').find('.productSelect');

        $select.find("option").each(function () {
            var txt = $.trim($(this).text());
            if (txt === optionName) {
                var img = $(this).data("img");
                var id = $(this).val();
                var variantId = $(this).val();
                $select.val($(this).val()).trigger('change');
                var available = $(this).data("available");

                if (!available) {
                    alert('Sold Out');
                    return;
                }

                const { tshirtGoal } = window.GIFT_CONFIG || { tshirtGoal: 100 };
                const productTags = $card.find('.card-product-tags').val().split(',');
                const isTier1Gift = productTags.includes(`gift-${tshirtGoal}`) || productTags.includes("gift-tier1");
                
                if (isTier1Gift) {
                    tryAddGift(variantId, isTier1Gift, function(){
                        $(".cart-sidebar").addClass("active");
                        $("body").addClass("active");
                    });
                    return; 
                }

                $.ajax({
                    type:'POST',
                    url:'/cart/add.js',
                    data: { id: id, quantity: 1 },
                    dataType:'json',
                    success:function(data) {
                        $(".cart-sidebar").addClass("active");
                        $("body").addClass("active");
                        cart_drawer_update();
                    },
                    error:function(err) {
                        console.log('Error', err);
                    }
                })
            }
        });
    });

    $(".card_option_upsell").on("change", function () {
        let optionName = "";
        $(this).closest('.product-options').find(".card_option_upsell:checked").each(function (e) {
            optionName += e !== 0 ? "-" : "";
            optionName += $(this).val();
        });
        let $select = $(this).closest('.product-varient').find('.productSelect');
        let $id = $(this).closest('.side-cart-slider-item-content').find('.product_id');

        $select.find("option").each(function () {
            var txt = $.trim($(this).text());
            if (txt === optionName) {
                var id = $(this).val();
                $select.val($(this).val()).trigger('change');
                $select.val(id);
                $id.val(id);
            }
        });
    });
});

    $(".cart-sidebar-open-btn").click(function (event) {
        event.preventDefault();
        $(".cart-sidebar").toggleClass("active");
        $("body").toggleClass("active");
    });

    $(".cart-sidebar-close-window-btn").click(function (event) {
        event.stopPropagation();
        $(".cart-sidebar").removeClass("active");
        $("body").toggleClass("active");
    });

    $(".side-cart-close-btn").click(function (event) {
        event.stopPropagation();
        $(".cart-sidebar").toggleClass("active");
        $("body").toggleClass("active");
    });

const navbar = document.querySelector(".navbar");
let lastScrollPosition = 0;
window.addEventListener("scroll", () => {
    let currentScrollPosition = window.pageYOffset;

    if (currentScrollPosition - lastScrollPosition > 22) {
        navbar.classList.add("hide");
        navbar.classList.remove("nav-fixed");
    } else {
        navbar.classList.add("nav-fixed");
        navbar.classList.remove("hide");
    }
    lastScrollPosition = currentScrollPosition;
})

function updateVariantAvailability() {
    let optionName = "";
    
    $("input:radio.option_input:checked").each(function (e) {
        optionName += e !== 0 ? "-" : "";
        optionName += $(this).val();
    });

    $("#productSelect option").each(function () {
        var txt = $.trim($(this).text());
        if (txt === optionName) {
            var img = $(this).data("img");
            var id = $(this).val();
            var inventory = $(this).data("inventory");
            
            $("#productSelect").val(id);
            $("#product_id").val(id);

            if (inventory > 0) {
                $(".addToCart").removeClass("sold_out");
                $(".atc-text").text("Add To Cart");
                
                $(".product-details-availability-text").html(
                    '<span class="icon"></span>' +
                    '<p>' + window.stockTexts.inStock + ' – ' + window.stockTexts.delivery + '</p>'
                );
                
            } else {
                $(".addToCart").addClass("sold_out");
                $(".atc-text").text("Sold Out");
                
                $(".product-details-availability-text").html(
                    '<span class="icon"></span>' +
                    '<p class="stock_out">' + window.stockTexts.outOfStock + '</p>'
                );
            }

            $(".featured-img").each(function (index) {
                var src = $(this).attr("src").split("?")[0];
                var cleanImg = img.split("?")[0];
                if (src === cleanImg) {
                    mainSwiper.slideToLoop(index, 500, false);
                }
            });
        }
    });
}

function updateGiftProgress(cartTotal) {
  const { showShirtGift } = window.GIFT_CONFIG || {};
  const { tshirt, freeShipping } = localGoals;
  
  const wrapper = document.querySelector(".side-cart-progress-bar-area");
  const shirtCheckpoint = document.querySelector(".checkpoint-shirt");
  
  // Use Free Shipping as the ultimate 100% target for the progress bar
  const maxGoal = freeShipping;
  const pct = maxGoal ? Math.min(((cartTotal + 0.01) / maxGoal) * 100, 100) : 0;
  
  if (wrapper) wrapper.style.setProperty("--progress", `${pct}%`);

  if (shirtCheckpoint) {
      shirtCheckpoint.style.display = showShirtGift ? "block" : "none";
      if (showShirtGift && maxGoal > 0) {
          shirtCheckpoint.style.left = `${(tshirt / maxGoal) * 100}%`;
          shirtCheckpoint.dataset.reached = cartTotal >= tshirt;
      }
  }

  const customerCurrency = (window.Shopify && Shopify.currency) ? Shopify.currency.active : "EUR";
  
  const formatMoney = (amount) => {
      return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: customerCurrency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0 
      }).format(amount);
  };

  let unlocked = [];
  let remaining = [];

  let isFreeShipping = cartTotal >= freeShipping;
  let fsDiff = freeShipping - cartTotal;

  if (showShirtGift && cartTotal >= tshirt) unlocked.push("<strong>FREE SUNGLASSES</strong>");
  if (isFreeShipping) unlocked.push("<strong>FREE SHIPPING</strong>");

  if (showShirtGift && cartTotal < tshirt) {
      remaining.push(`<strong>${formatMoney(tshirt - cartTotal)}</strong> for <strong>FREE SUNGLASSES</strong>`);
  }

  if (!isFreeShipping) {
      remaining.push(`<strong>${formatMoney(fsDiff)}</strong> for <strong>FREE SHIPPING</strong>`);
  }

  let message = "";
  if (unlocked.length > 0 && remaining.length === 0) {
      message = `You've unlocked:<br>${unlocked.join(" and ")}!`;
  } else if (unlocked.length > 0) {
      message = `${unlocked.join(" & ")} unlocked!<br>Spend ${remaining.join(" and ")}`;
  } else {
      message = `Spend only ${remaining.join(" and ")}`;
  }

  if ($('#progressText').length) {
      $('#progressText').html(`<p>${message}</p>`);
  }
}

$(document).ready(function() {
    updateVariantAvailability();
    
    fetchShopifyRate().then(function() {
        getCartData().then(function(data) {
            const eurTotal = Number((data.cartTotal / activeCurrencyRate).toFixed(2));
            saveEURTotalToCart(eurTotal).then(function() {
                console.log("Cart EUR attribute updated");
            });
            updateGiftProgress(data.cartTotal);
        });
    });
});

$(".option_input").on("change", function () {
    var vname = $(this).val();
    $(this).closest('.product-details-varient').find('.selected_option').text(vname);
    updateVariantAvailability();
});

    $('.addToCart').on('click', function(e){
        e.preventDefault();
        const form = $(this).closest('#product_form');
        const price = parseInt(form.find('.product-price').val()); 
        const isGift = (price === 0);
        if(!isGift){
             $.ajax({
            type:'POST',
            url:'/cart/add.js',
            data:form.serialize(),
            dataType:'json',
            success:function(data) {
                $(".cart-sidebar").addClass("active");
                $("body").addClass("active");
                cart_drawer_update();
            }
        });
        return;
        }

        const { tshirtGoal } = window.GIFT_CONFIG || { tshirtGoal: 100 };
        const productTags = form.find('.product-tags').val().split(',');
        const isTier1Gift = productTags.includes(`gift-${tshirtGoal}`) || productTags.includes("gift-tier1");
        const variantId = form.find('#product_id').val();
        
        tryAddGift(variantId, isTier1Gift, function(){
            $(".cart-sidebar").addClass("active");
            $("body").addClass("active");
        });
    });

    $('.upsellAddToCart').on('click', function(e){
        e.preventDefault();
        $.ajax({
            type:'POST',
            url:'/cart/add.js',
            data:$(this).closest('.upsell_form').serialize(),
            dataType:'json',
            success:function(data) {
                $(".cart-sidebar").addClass("active");
                $("body").addClass("active");
                cart_drawer_update();
            },
            error:function(err) {
                console.log('Error', err);
            }
        })
    })

    $(document).on('click', '.gift-add-btn', function(e) {
        e.preventDefault();
        const parent = $(this).closest(".gift-item");
        const variantId = parent.find(".gift-variant-select").val();
        
        const { tshirtGoal } = window.GIFT_CONFIG || { tshirtGoal: 100 };
        const giftproductTags = parent.find('.gift-product-tags').val().split(',');
        const isTier1Gift = giftproductTags.includes(`gift-${tshirtGoal}`) || giftproductTags.includes("gift-tier1");
        
        tryAddGift(variantId, isTier1Gift);
    })

function tryAddGift(variantId, isTier1Gift, callback) {
    const { tshirtGoal } = window.GIFT_CONFIG;
    $.ajax({
        url: "/cart.js",
        type: "GET",
        dataType: "json",
        success: function (cart) {
            const customerCurrency = (window.Shopify && Shopify.currency) ? Shopify.currency.active : "EUR";
            const multiplier = getSubunitMultiplier(customerCurrency);

            const giftExists = cart.items.some(item =>
                item.properties && item.properties.gift
            );
            let cartTotal = cart.total_price / multiplier;

            const formatMoney = (amount) => new Intl.NumberFormat(undefined, {
                style: 'currency', 
                currency: customerCurrency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(amount);

            if (giftExists) {
                alert("You have already selected your free gift.");
                return;
            }

            if (isTier1Gift && cartTotal < localGoals.tshirt) {
                alert(`You must spend ${formatMoney(localGoals.tshirt)} to unlock this gift.`);
                return;
            }

            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    id: variantId,
                    quantity: 1,
                    properties: {
                        gift: `${tshirtGoal} Spend Gift`
                    }
                },
                dataType: "json",
                success: function () {
                    cart_drawer_update();
                    if (callback) callback();
                },
                error: function (xhr) {
                    console.error("Error adding gift:", xhr.responseText);
                }
            });
        }
    });
}

function disableCheckout(disable) {
  const btn = document.querySelector('[name="checkout"]');
  if (!btn) return;

  btn.disabled = disable;
  btn.classList.toggle('disabled', disable);
}

function itemPlus(e, el) {
    disableCheckout(true)
  var id = $(el).data("id");
  var qty = $(el).prev().val();
  qty = parseInt(qty) + 1;

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: qty,
    },
    dataType: "json",
    success: function (data) {
      cart_drawer_update();
      $(el).prev().val(qty);
    },
    error: function (err) {
      console.log("Error");
    },
  });
}

function itemMinus(e, el) {
    disableCheckout(true)
  var id = $(el).data("id");
  var qty = $(el).next().val();
  qty = parseInt(qty) - 1;

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: qty,
    },
    dataType: "json",
    success: function (data) {
      cart_drawer_update();
      if (qty >= 1) {
        $(el).next().val(qty);
      }
    },
    error: function (err) {
      console.log("Error");
    },
  });
}

function itemRemoved(e, el) {
    disableCheckout(true)
  var id = $(el).data("id");
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: parseFloat(id),
      quantity: 0,
    },
    dataType: "json",
    success: function (data) {
      cart_drawer_update();
    },
    error: function (err) {
      console.log("Error");
    },
  });
}

function removeGiftItem(itemKey) {
    disableCheckout(true)
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: itemKey,
      quantity: 0
    })
  }).then(() => {
    cart_drawer_update();
  });
}

var timeInSecs;
var ticker;

function startTimer(secs) {
    timeInSecs = parseInt(secs);
    ticker = setInterval("tick()", 1000);
}

function tick() {
    var secs = timeInSecs;
    if (secs > 0) {
        timeInSecs--;
    } else {
        clearInterval(ticker);
        startTimer(10 * 60); 
    }

    var mins = Math.floor(secs / 60);
    secs %= 60;
    var pretty = ((mins < 10) ? "0" : "") + mins + ":" + ((secs < 10) ? "0" : "") + secs;

    document.getElementById("side_cart_timer").innerHTML = pretty;
}

startTimer(10 * 60); 

$(function () {
    $('.primary-btn')
        .on('mouseenter', function (e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('span').css({
                top: relY,
                left: relX
            })
        })
        .on('mouseout', function (e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('span').css({
                top: relY,
                left: relX
            })
        });
});

$(function () {
    $('.secondary-btn')
        .on('mouseenter', function (e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('span').css({
                top: relY,
                left: relX
            })
        })
        .on('mouseout', function (e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).find('span').css({
                top: relY,
                left: relX
            })
        });
});

new Swiper(".megaSwipertitle", {
        slidesPerView: 3.5,
        spaceBetween: 5,
        navigation: {
        nextEl: ".swiper-button-nexttitle",
        prevEl: ".swiper-button-prevtitle",
    },
    breakpoints: {
        0: { slidesPerView: 3.3 },
        768: { slidesPerView: 3.3 },
        1024: { slidesPerView: 3.5 },
    },
});

  var swiper3 = new Swiper(".card-slider", {
    slidesPerView: 1,
    spaceBetween: 4,
    loop: false,
    grabCursor: true,
    scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
    },
  });

  function updateSwiperById(id, swatches) {
    var slides = swatches.find(".swiper-slide")
    var index = 0;
    for (let i = 0; i < slides.length; i++) {
        const element = $(slides[i]).attr("data-media-id");
        if (element == id) {
            index = i;
        }
    }
    $(swatches)[0].swiper.slideTo(index)
}

var swiper = new Swiper(".side-cart-item-slider", {
    slidesPerView: 1.5,
    spaceBetween: 10,
    grabCursor: true,
    loop: false,
    navigation: {
        nextEl: '.side-cart-slider-btn-next',
        prevEl: '.side-cart-slider-btn-prev',
    },
    breakpoints: {
        1: { slidesPerView: 1.2 },
        440: { slidesPerView: 1.5 }
    }
});

var swiper = new Swiper(".announcement-slider", {
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    autoplay: {
        delay: 4000,
        disableOnInteraction: true,
    },
});

var thumbSwiper = new Swiper(".product-details-thumb-slider", {
      loop: false,
      slidesPerView:4.2,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      breakpoints: {
        576: { slidesPerView: 6.2 },
      },
    });
var mainSwiper = new Swiper(".product-details-slider", {
      slidesPerView: 1,
      spaceBetween: 10,
         navigation: {
        nextEl: '.product-slider-button-next',
        prevEl: '.product-slider-button-prev',
      },
       breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 17,
    }
  },
      thumbs: {
        swiper: thumbSwiper,
        multipleActiveThumbs: false,
      },
    });

var swiper = new Swiper(".img-gallery-slider", {
    infinity: true,
    slidesPerView: 4.5,
    spaceBetween: 4,
    grabCursor: true,
    loop: true,
    speed: 500,
     autoplay: {
        delay: 4000,
        disableOnInteraction: true,
    },
    breakpoints: {
        1: { slidesPerView: 1.25 },
        576: { slidesPerView: 3.2 },
        993: { slidesPerView: 3.5 },
        1140: { slidesPerView: 4.5 },
        1290: { slidesPerView: 4.5 }
    }
});

var swiper = new Swiper(".testimonial-slider", {
  slidesPerView: 3.5,
  spaceBetween: 10,
  grabCursor: true,
  loop: false,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: true,
  },
  breakpoints: {
    1: { slidesPerView: 1.1 },
    576: { slidesPerView: 2.3 },
    993: { slidesPerView: 2.7 },
    1140: { slidesPerView: 3.3 },
    1290: { slidesPerView: 3.5 }
  }
});

var swiper = new Swiper(".sidebar-images", {
  slidesPerView: 2.5,
  spaceBetween: 10,
  grabCursor: true,
  loop: false,
  scrollbar: {
    el: ".swiper-scrollbar",
    hide: true,
  }
});

document.querySelectorAll(".product-slider__buttons").forEach((btnWrapper) => {
  const btn = btnWrapper.querySelector(".swiper-button-next, .swiper-button-prev");
  if (!btn) return;

  btnWrapper.addEventListener("mousemove", (e) => {
    const rect = btnWrapper.getBoundingClientRect();
    const x = e.clientX - rect.left - btn.offsetWidth / 2;
    const y = e.clientY - rect.top - btn.offsetHeight / 2;

    btn.style.transform = `translate(${x}px, ${y}px)`;
  });

  btnWrapper.addEventListener("mouseleave", () => {
    btn.style.transform = "translate(0, 0)";
  });
});

document.querySelectorAll(".product-slider__section").forEach(function(section) {
    const wrapper = section.querySelector(".product-slider__wrapper");
    const mainSlider = section.querySelector(".product-slider__product-swiper");
    const thumbSlider = section.querySelector(".product-slider__image-swiper");
    const nextBtn = section.querySelector(".product-slider__buttons.product-button-next");
    const prevBtn = section.querySelector(".product-slider__buttons.product-button-prev");
    const paginationEl = section.querySelector(".product-slider__pagination.swiper-pagination");
    const swiperMain = new Swiper(mainSlider, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 1000,
        keyboard: true,
        autoplay: {
            delay: 1000,
            disableOnInteraction: false,
        },
        pagination: {
            el: paginationEl,
            clickable: true,
        },
        navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
        },
        effect: "slide",
    });

    const swiperThumb = new Swiper(thumbSlider, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        speed: 1000,
        watchSlidesProgress: true,
        effect: "slide",
        breakpoints: {
            0: {
                autoplay: { delay: 1000, disableOnInteraction: false },
            },
            767: {
                autoplay: { delay: 1000, disableOnInteraction: false },
            },
        },
    });

    swiperMain.controller.control = swiperThumb;
    swiperThumb.controller.control = swiperMain;
    
    wrapper.addEventListener("mouseenter", function() {
        swiperMain.autoplay?.stop();
        swiperThumb.autoplay?.stop();
    });
    wrapper.addEventListener("mouseleave", function() {
        swiperMain.autoplay?.start();
        swiperThumb.autoplay?.start();
    });
});

const swipe = new Swiper('.bestseller-section .product-slider__image-swiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 1000,
    watchSlidesProgress: true,
    effect: "slide",
    autoplay: { delay: 1000, disableOnInteraction: false },
});

document.addEventListener('cart:change', () => {
  $(".cart-sidebar").addClass("active");
  $("body").addClass("active");

  if (typeof cart_drawer_update === 'function') {
    cart_drawer_update();
  }
});

function sideCartHTML(cartTotal) {
  return fetch("/?section_id=custom_side_cart")
    .then(res => res.text())
    .then(html => {
      var cart_html = $(html);
      $("#gift-offer-dynamic").html($("#gift-offer-dynamic", cart_html).html());
      $("#cart_items").html($("#cart_items", cart_html).html());
      $(".cart_footer").html($(".cart_footer", cart_html).html());
      
      const dynamicShippingText = document.getElementById("dynamic-shipping-text");
      if (dynamicShippingText && typeof cartTotal !== 'undefined') {
          if (cartTotal >= localGoals.freeShipping) {
              dynamicShippingText.innerHTML = "<strong>Free</strong>";
          } else {
              dynamicShippingText.innerHTML = "Calculated in checkout";
          }
      }
    });
}

async function cart_drawer_update() {
    const data = await getCartData();
    const cartTotal = data.cartTotal;
    const { tshirtGoal } = window.GIFT_CONFIG || { tshirtGoal: 100 };
    
    const eurTotal = Number((cartTotal / activeCurrencyRate).toFixed(2));
    
    updateGiftProgress(cartTotal);

    const dynamicShippingText = document.getElementById("dynamic-shipping-text");
    if (dynamicShippingText) {
        if (cartTotal >= localGoals.freeShipping) {
            dynamicShippingText.innerHTML = "<strong>Free</strong>";
        } else {
            dynamicShippingText.innerHTML = "Calculated in checkout";
        }
    }

  $.getJSON("/cart.js", function (cart) {
     cart.items.forEach(item => {
        if (!item.properties || !item.properties.gift) return;
        let giftName = item.properties.gift;
        
        if (cartTotal < localGoals.tshirt && giftName.includes(`${tshirtGoal} Spend Gift`)) {
            removeGiftItem(item.key);
        }
     });

    var total_items = cart.item_count;

    if(total_items > 0) {
        $('.cart-sidebar').removeClass('empty_cart')
        $("#giftOffer").css("display", "block");
    }else {
        $('.cart-sidebar').addClass('empty_cart')
        $("#giftOffer").css("display", "none");
    }

    $(".side-cart-item-number").text(total_items);
    $(".cart_count").text(total_items);  
  });

    saveEURTotalToCart(eurTotal).then(function() {
         sideCartHTML(cartTotal).then(() => {
             disableCheckout(false)
         });
    });
}

$(document).ready(function(){
     const $btn = $("#aatc");
    const $title = $("#ptt");
    if (!$btn.length || !$title.length) return;
    function updateFloatingButton() {
    if (window.innerWidth >= 768) {
      $btn.removeClass("is-floating");
      return;
    }
    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();

    const titleTop = $title.offset().top;
    const btnStaticTop = $btn.parent().offset().top; 
    const buffer = 20;

    const passedTitle = (scrollTop + windowHeight > titleTop + buffer);
    const passedActualBtn = (scrollTop > btnStaticTop);

    if (passedTitle && !passedActualBtn) {
      $btn.removeClass("is-floating");
    } else {
      $btn.addClass("is-floating");
    }
  }
  $(window).on("scroll resize", updateFloatingButton);
  updateFloatingButton();
});